module.exports = __webpack_public_path__ + "img/monitoring-load-data.37edc171.svg";